module.exports = __webpack_public_path__ + "img/home_pic_zzsq.c0ab6542.png";